import { useEffect, useState } from 'react'

import type { ApiResponse } from '../types/api'
import { api } from '../utils/api-client'

interface PlatformInfo {
  download_link: string
  version: string
}

const useAppDownload = () => {
  const [downloadLinks, setDownloadLinks] = useState<{
    android: PlatformInfo
    ios: PlatformInfo
  }>({
    android: {
      download_link: '',
      version: '',
    },
    ios: {
      download_link: '',
      version: '',
    },
  })

  useEffect(() => {
    const checkForUpdate = async () => {
      const updateRes = await api.post<
        ApiResponse<{
          android: PlatformInfo
          ios: PlatformInfo
        }>
      >('/ajax_datav2.php', {
        type: 'get_app_version',
      })
      const { status, info } = updateRes.data
      if (
        status === 1
      ) {
        setDownloadLinks(info)
      }
    }
    checkForUpdate()
  }, [])

  return downloadLinks
}

export default useAppDownload
